var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66824 15.685V13.9007H5.09569L6.85771 8.03474C6.97666 7.64814 7.19613 7.33975 7.51612 7.10957C7.83611 6.8794 8.1891 6.76401 8.57511 6.76342H11.2516C11.6382 6.76342 11.9915 6.8788 12.3115 7.10957C12.6315 7.34035 12.8506 7.64874 12.969 8.03474L14.731 13.9007H16.1585V15.685H3.66824ZM9.02119 4.9791V0.518311H10.8055V4.9791H9.02119ZM14.3295 7.18719L13.0582 5.91587L16.2254 2.77101L17.4744 4.02003L14.3295 7.18719ZM15.2663 11.2242V9.43989H19.7271V11.2242H15.2663ZM5.49717 7.18719L2.35231 4.02003L3.60133 2.77101L6.76849 5.91587L5.49717 7.18719ZM0.0996094 11.2242V9.43989H4.5604V11.2242H0.0996094Z",
    fill: "url(#paint0_linear_4847_63933)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4847_63933",
    x1: 0.0996094,
    y1: 0.518311,
    x2: 20.1214,
    y2: 1.05806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE594"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.37257023b2df2d2be8d150ad06122285.svg";
export { ForwardRef as ReactComponent };